const BRAND = "PROAC TRANSMISSION";
const LEGACY = /^PROAC Transmission vient de réaliser la (cession|vente) de (la société |la |l')?/i;
const bare = (s) => s.replace(/^(SAS|SARL|SA|EURL|SASU)\s+/i, "").toLowerCase();

export const soldText = (name = "", description = "") => {
  const d = description.trim();
  if (d.toUpperCase().startsWith(`${BRAND} A VENDU`)) return d;
  const rest = d.replace(LEGACY, "");
  if (rest !== d && (rest.toLowerCase().startsWith(name.toLowerCase()) || rest.toLowerCase().startsWith(bare(name)))) return `${BRAND} a vendu ${rest}`;
  return `${BRAND} a vendu ${name}.${rest ? ` ${rest.charAt(0).toUpperCase()}${rest.slice(1)}` : ""}`;
};

export const forSaleText = (title = "", description = "", sold = false) => {
  const d = (description || "").trim();
  if (/^PROAC TRANSMISSION (VEND|A VENDU)/i.test(d)) return d;
  return `${BRAND} ${sold ? "a vendu" : "vend"} « ${title} ».${d ? ` ${d}` : ""}`;
};
